"use client";
import React, { useState } from "react";
import { EquipmentCategory } from "./types";
import { EquipmentItem } from "./EquipmentItem";
import { NavigationButtons } from "./NavigationButtons";

interface EquipmentSelectionStepProps {
  equipmentCategories: EquipmentCategory[];
  onUpdateQuantity: (itemId: string, delta: number) => void;
  getTotalAmount: () => number;
  getTotalTip: () => string;
  getStudioEquip: () => string;
  onPrevStep: () => void;
  onNextStep: () => void;
}

export const EquipmentSelectionStep: React.FC<EquipmentSelectionStepProps> = ({
  equipmentCategories,
  onUpdateQuantity,
  getTotalAmount,
  getTotalTip,
  getStudioEquip,
  onPrevStep,
  onNextStep,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [openCategory, setOpenCategory] = useState<string[]>([]);

  const getFilteredCategories = () => {
    if (!searchQuery) return equipmentCategories;
    return equipmentCategories
      .map((cat) => ({
        ...cat,
        items: cat.items.filter((item) =>
          item.name.toLowerCase().includes(searchQuery.toLowerCase()),
        ),
      }))
      .filter((cat) => cat.items.length > 0);
  };

  const toggleOpenCategory = (slotKey: string) => {
    console.log(openCategory);
      setOpenCategory((prev) => {
        const index = prev.indexOf(slotKey);
        if (index === -1) {
          return [...prev, slotKey];
        } else {
          return prev.filter((slot) => slot !== slotKey);
        }
      });
  };
  // <div className="flex whitespace-pre-line top-20 left-10 gap-3 px-5 py-4 -mb-12 max-sm:mb-0 text-black bg-stone-300 bg-opacity-90 rounded-lg w-2/3 max-sm:w-full min-w-[400px] max-w-[500px] shadow-[rgba(0,0,0,0.35)_0px_4px_15px_2px] z-[1000] max-sm:inset-x-5 max-sm:max-w-none">
            

  return (
    <>
      <h2 className="mb-8 text-2xl font-light text-center uppercase">
        ДОПОЛНИТЕЛЬНОЕ ОБОРУДОВАНИЕ 
      </h2>
      {getStudioEquip() && (
            <div className="flex whitespace-pre-line top-20 left-10 gap-3 px-5 py-4 -mb-12 max-sm:mb-0 text-black bg-white border-solid border-gray-400
 rounded-xl border w-2/3 max-sm:w-full max-w-[500px] z-[1000] max-sm:inset-x-5 max-sm:max-w-none">
              {getStudioEquip()}
            </div>)
      }

      <NavigationButtons
        onNext={onNextStep}
      />
      <div className="mb-5">
        <input
          className="p-3 w-full text-sm border border-solid border-neutral-200"
          type="text"
          placeholder="Поиск оборудования / услуги"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="grid gap-8 mb-10">
        {getFilteredCategories().map((category) => (
          <section key={category.id}>

            <button
              className="flex justify-between items-center align-middle p-4 bg-transparent w-full"
              onClick={() => toggleOpenCategory(category.id)}
            >
              <h3 className="mr-1 text-sm font-light uppercase">
                {category.name}
              </h3>
              <div
                className="ml-2.5 w-2.5 h-2.5 border-r-2 border-b-2 border-solid transition-transform border-black duration-[0.3s] ease-[ease]"
                style={{
                  transform: !openCategory.includes(category.id) ? "rotate(225deg)" : "rotate(45deg)",
                }}
              />
            </button>
            <div
              className="overflow-hidden duration-[0.3s] ease-[ease] transition-[height]"
              style={{
                height: !openCategory.includes(category.id) ? "auto" : "0"
              }}
            >
              <div className="grid gap-5 grid-cols-[repeat(auto-fill,minmax(250px,1fr))] max-sm:grid-cols-[1fr]">
                {category.items.map((item) => (
                  <EquipmentItem
                    key={item.id}
                    item={item}
                    onUpdateQuantity={onUpdateQuantity}
                  />
                ))}
              </div>
            </div>
          </section>
        ))}
      </div>

      <NavigationButtons
        onBack={onPrevStep}
        onNext={onNextStep}
        showTotal={true}
        floatNext={true}
        totalAmount={getTotalAmount()}
        totalTip={getTotalTip()}
        
      />
      <div/>
    </>
  );
};
